import {TweenMax} from 'gsap';

export const getViewport = element => {
    return element.closest('.viewport__slide');
};

export const scrollTo = (element, position = 'top') => {
    const slide = getViewport(element);
    const rect = element.getBoundingClientRect();
    let y;

    if (position === 'top') {
        y = rect.top + slide.scrollTop;
    } else if (position === 'center') {
        y = rect.top + slide.scrollTop - window.innerHeight * 0.5 + rect.height * 0.5;
    } else if (position === 'end') {
        y = rect.top + slide.scrollTop + Math.abs(window.innerHeight - rect.height);
    }

    TweenMax.to(slide, 0.5, {scrollTop: y});
};


// WEBPACK FOOTER //
// ./js/scroll-to.js